// General
import React from "react";
import { useNavigate } from "react-router-dom";

// Formik & MUI
import { Formik, Form, Field } from "formik";
import { TextField } from "@mui/material";

// Assets
import logo from "../assets/images/logo.png";

function ForgetPassword() {
  // Navigation
  const navigate = useNavigate();

  // Handlers
  const handleForgotPassword = (values) => {
    console.log("Şifre sıfırlama isteği:", values.email);
    alert("Şifre sıfırlama linki mailinize gönderildi!");
    navigate("/girisyap"); // işlem sonrası login sayfasına yönlendirme
  };

  // HTML
  return (
    <div className="admin-layout">
      <div className="authpage-container">
        <div className="card authcard">
          {/* Header */}
          <div className="authcard-header">
            <img src={logo} alt="logo" className="authpage-logo" />
            <p className="authpage-text mt-5">Şifremi Unuttum</p>
            <p className="authpage-subtext">
              Lütfen e-posta adresinizi giriniz. Şifre sıfırlama linki
              göndereceğiz.
            </p>
          </div>

          {/* Form */}
          <div className="authcard-form ">
            <Formik
              initialValues={{ email: "" }}
              onSubmit={handleForgotPassword}
            >
              {({ values, handleChange, handleBlur, touched, errors }) => (
                <Form style={{ width: "100%" }}>
                  {/* Email */}
                  <p className="auth-input-label">E-Postanız</p>
                  <Field
                    as={TextField}
                    id="ForgotPage_email"
                    name="email"
                    label="Email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    className="muitextfield-auth"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                  {/* Submit */}
                  <button type="submit" className="login-btn w-100 mt-3">
                    Şifre Sıfırlama Linki Gönder
                  </button>

                  {/* Navigation */}
                  <span
                    className="forgot-password"
                    onClick={() => navigate("/girisyap")}
                  >
                    ← Giriş Sayfasına Dön
                  </span>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
